import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import template from './Account.vue';

import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import Button from '@/components/Button';
import auth from '@/store/modules/auth';
import { Lang, PasswordForm, PersonalDataForm } from '@/store/models';
import store from '@/store';
import { validation } from '@/_helpers/validation';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		ValidationProvider,
		MDTextFieldWithValidation,
		Button
	}
})
export default class Account extends Vue {
	loading: boolean = false;

	form: { personalData: PersonalDataForm; password: PasswordForm } = {
		personalData: {
			name: '',
			email: '',
			localization: {
				language: ''
			}
		},
		password: {
			oldPassword: '',
			password: '',
			passwordConfirmation: '',
			logoutAllDevices: false
		}
	};

	currentLang: { text: string; value: string } = {
		text: '',
		value: ''
	};

	languages = [
		{ text: 'Nederlands', value: 'nl' },
		{ text: 'English', value: 'en' }
	];

	mounted(): void {
		this.get(false);
	}

	async get(force: boolean): Promise<void> {
		this.loading = true;
		try {
			await auth.getSelf(force);
		} catch (error) {
			store.commit('openNotifier', { text: `Er ging wat fout tijdens het ophalen van de gegevens`, color: 'error' });
		} finally {
			this.loading = false;
		}
		this.form.personalData.email = auth.self.email;
		this.form.personalData.name = auth.self.name;
		this.form.personalData.localization.language = auth.self.localization.language;
		const tmp = this.languages.find((l) => l.value === auth.self.localization.language);
		if (tmp !== undefined) {
			this.currentLang = tmp;
		}
	}

	async submit(): Promise<void> {
		let successful = false;
		this.loading = true;
		if (
			this.form.personalData.name !== auth.self.name ||
			this.form.personalData.email !== auth.self.email ||
			this.form.personalData.localization.language !== auth.self.localization.language
		) {
			successful = await this.updatePersonalData();
			if (successful) {
				this.get(true);
			}
		}
		if (
			this.form.password.oldPassword !== '' ||
			this.form.password.password !== '' ||
			this.form.password.passwordConfirmation !== ''
		) {
			successful = await this.updatePassword();
		}
		if (successful) {
			store.commit('openNotifier', { text: `De gegevens zijn opgeslagen`, color: 'success' });
		}

		this.loading = false;
	}

	async updatePersonalData(): Promise<boolean> {
		const isValid = await (this.$refs.formData as any).validate();
		if (!isValid) {
			return false;
		}
		try {
			await auth.selfUpdate(this.form.personalData);
			return true;
		} catch (error) {
			(this.$refs.formData as any).setErrors(validation.getErrors(error.data.errors));
			return false;
		}
	}

	async updatePassword(): Promise<boolean> {
		const isValid = await (this.$refs.formPassword as any).validate();
		if (!isValid) {
			return false;
		}
		try {
			await auth.selfPatchPassword(this.form.password);
			this.form.password = {
				oldPassword: '',
				passwordConfirmation: '',
				password: '',
				logoutAllDevices: false
			};
			(this.$refs.formPassword as any).reset();
			return true;
		} catch (error) {
			(this.$refs.formPassword as any).setErrors(validation.getErrors(error.data.errors));
			return false;
		}
	}

	updateLang(lang: Lang) {
		this.form.personalData.localization.language = lang;
	}
}
